<template>
  <div class="dd-calendar">
    <div class="d-flex justify-content-between">
      <label class="my-auto pb-2" :class="{ 'Required': isRequired }">
        {{ label }}
      </label>
      <div v-if="!isConditionControl">
        <v-row align="center" justify="center" no-gutters>
          <v-col md="4" class="pb-2">
            <span :class="{ 'primary--text': !isGregorianInternal }">هجري</span>
          </v-col>
          <v-col md="4">
            <n-switch v-model="isGregorianInternal" flat inset dense hide-details class="dd-switch-aligned"
              @change="calendarTypeChange"></n-switch>
          </v-col>
          <v-col md="4" class="pb-2">
            <span :class="{ 'primary--text': isGregorianInternal }">ميلادي</span>
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="row no-gutters">
      <div class="col-4">
        <v-autocomplete :id="'year' + _uid" :ref="'year' + _uid" :items="years" v-model="selectedYear"
          no-data-text="لا يوجد سنة بهذه القيمة" label="السنة" append-icon="mdi-chevron-down" solo hide-details
          height="50" class="rounded-0" maxlength="4" @click.stop="" @keypress="isNumber($event)"
          @change="onSelectedYearChange">
        </v-autocomplete>
      </div>
      <div class="col-4 px-2">
        <v-autocomplete :id="'month' + _uid" :items="months" item-value="value" item-text="name"
          no-data-text="لا يوجد شهر بهذه القيمة" label="الشهر" return-object solo hide-details autocomplete="off"
          height="50" class="rounded-0 wide-input" maxlength="2" append-icon="mdi-chevron-down" v-model="selectedMonth"
          @click.stop="" @change="onSelectedMonthChange">
        </v-autocomplete>
      </div>
      <div class="col-4">
        <v-autocomplete :id="'day' + _uid" :ref="'day' + _uid" :items="days" label="اليوم"
          no-data-text="لا يوجد يوم بهذه القيمة" return-object hide-details solo height="50" class="rounded-0"
          maxlength="2" append-icon="mdi-chevron-down" v-model="selectedDay" @click.stop="" @keypress="isNumber($event)"
          @change="onSelectedDayChange">
        </v-autocomplete>
      </div>
      <span v-if="isConditionControl && !isValid" style="color:#f75555">الحقل مطلوب</span>
    </div>
  </div>
</template>
<script lang="ts">
    import { Component, Vue, Prop } from 'vue-property-decorator';
    import moment from 'moment';
    import NSwitch from '@/components/nSwitch.component.vue';
    import { DDCalendarDate } from '@/models/common';
    //@ts-ignore
    import momenthijri from 'moment-hijri';

    interface SelectedMonth {
        name: string;
        value: number;
    }

    @Component({
        components: {
            NSwitch,
        },
    })
    export default class DropDownCalendarComponent extends Vue {
        @Prop({ default: '' }) label!: string;
        @Prop({ default: 100 }) yearsCount!: number;
        @Prop({ default: 0 }) futureYearsCount!: number;
        @Prop({ default: true }) isGregorian!: boolean;
        @Prop({ default: '' }) date!: string;
        @Prop({ default: false }) isRequired!: boolean;
        @Prop({ default: '' }) maxDate!: string;
        @Prop({ default: '' }) minDate!: string;
        @Prop({ default: false }) isConditionControl!: string;
        @Prop({ default: -1 }) index!: number;
        @Prop({ default: '' }) selectedDate!: string;
        isValid = true;
        maxDateInternal = '';
        minDateInternal = '';
        isGregorianInternal = true;
        intSelectedDate = new Date();
        currentDate = '';
        years = [] as number[];
        months = [] as SelectedMonth[];
        days = [] as number[];
        selectedYear = 0;
        selectedMonth = null as SelectedMonth | null;
        selectedDay = 0;
        bindedDate = '';

        gregorianMonths = [
            'يناير - 1',
            'فبراير - 2',
            'مارس - 3',
            'أبريل - 4',
            'مايو - 5',
            'يونيو - 6',
            'يوليو - 7',
            'أغسطس - 8',
            'سبتمبر - 9',
            'أكتوبر - 10',
            'نوفمبر - 11',
            'ديسمبر - 12',
        ];
        hijriMonths = [
            'محرّم - 1',
            'صفر - 2',
            'ربيع الأول - 3',
            'ربيع الآخر - 4',
            'جمادى الأول - 5',
            'جمادى الآخر - 6',
            'رجب - 7',
            'شعبان - 8',
            'رمضان - 9',
            'شوّال - 10',
            'ذو القعدة - 11',
            'ذو الحجة - 12',
        ];

        //set max date internal based on directive max date
        setMaxDateInternal() {
            if (this.maxDate.trim().toLowerCase() != '') {
                if (this.maxDate.toLowerCase() == 'today') {
                    this.maxDateInternal = this.isGregorian ?
                        moment().format('YYYY-MM-DD') : momenthijri().format('iYYYY-iMM-iDD');
                }
                else {
                    this.maxDateInternal = this.isGregorian ?
                        moment(this.maxDate.trim(), 'yyyy-MM-dd').format('YYYY-MM-DD') : moment(this.maxDate.trim(), 'yyyy-MM-dd').format('iYYYY-iMM-iDD');
                }
            }
        }

        //set min date internal based on directive min date
        setMinDateInternal() {

            if (this.minDate.trim().toLowerCase() != '') {
                if (this.minDate.trim().toLowerCase() == 'today') {
                    this.minDateInternal = this.isGregorian ?
                        moment().format('YYYY-MM-DD') : momenthijri().format('iYYYY-iMM-iDD');
                }
                else {
                    this.minDateInternal = this.minDate.trim().toLowerCase();
                }

            }
        }


        mounted() {
            moment.locale('en-us');
            this.isGregorianInternal = this.isGregorian;

            this.setMaxDateInternal() //set max date internal based on directive max date
            this.setMinDateInternal() //set min date internal based on directive min date

            //@ts-ignore
            this.$refs['day' + this._uid].lastItem = 31;
            if (this.isGregorian) {
                this.currentDate = moment().format('YYYY-MM-DD');
            } else {
                this.currentDate = momenthijri().format('iYYYY-iMM-iDD');
            }
            this.generateYears();
            //@ts-ignore
            this.$refs['year' + this._uid].lastItem = this.years.length;
            this.generateMonths();
            if (this.selectedDate != '') {
                var splitted = this.selectedDate.split('-');
                if (splitted && this.isGregorian) {
                    this.selectedYear = parseInt(splitted[0]);
                    this.selectedMonth = {} as SelectedMonth;
                    this.selectedMonth.value = parseInt(splitted[1]);
                    var name = this.gregorianMonths.find(x => {
                        if (this.selectedMonth) {
                            var monthNumber = this.selectedMonth.value.toString().startsWith('0') ? this.selectedMonth.value.toString()[1] : this.selectedMonth.value.toString();
                            return x.includes(monthNumber);
                        }
                    });
                    if (name) {
                        this.selectedMonth.name = name;
                    }
                    this.getDays(this.selectedMonth.value, this.selectedYear);
                    this.selectedDay = parseInt(splitted[2]);
                }
                else {
                    this.selectedYear = parseInt(splitted[0]);
                    this.selectedMonth = {} as SelectedMonth;
                    this.selectedMonth.value = parseInt(splitted[1]);
                    var name = this.hijriMonths.find(x => {
                        if (this.selectedMonth) {
                            var monthNumber = this.selectedMonth.value.toString().startsWith('0') ? this.selectedMonth.value.toString()[1] : this.selectedMonth.value.toString();
                            return x.includes(monthNumber);
                        }
                    });
                    if (name) {
                        this.selectedMonth.name = name;
                    }
                    this.getDays(this.selectedMonth.value, this.selectedYear);
                    this.selectedDay = parseInt(splitted[2]);
                }


            }
        }
        generateYears() {
            this.years = [];
            let year = Number.parseInt(this.currentDate.split('-')[0], 10);
            let yearsToAdd = year - this.yearsCount;
            while (year != yearsToAdd) {
                this.years.push(year);
                year--;
            }
            if (this.futureYearsCount > 0) {
                let year = Number.parseInt(this.currentDate.split('-')[0], 10);
                let futureYears = year + this.futureYearsCount;
                for (var i = year + 1; i <= futureYears; i++) {
                    this.years.unshift(i);
                }
            }
            if (this.maxDateInternal != '') {
                let maxYear = Number.parseInt(this.maxDateInternal.split('-')[0], 10);
                if (this.selectedYear == maxYear) {
                    this.years = this.years.filter(function (yr, idx) {
                        return yr <= maxYear;
                    });
                }
            }
            //add minimum date
            if (this.minDateInternal != '') {
                var minDateGreg = this.minDateInternal;
                if (this.isGregorianInternal) {
                    minDateGreg = momenthijri(this.minDateInternal.trim(), 'iYYYY-iMM-iDD').format('YYYY-MM-DD');
                }
                let minYear = Number.parseInt(minDateGreg.split('-')[0], 10);
                let minMonth = Number.parseInt(minDateGreg.split('-')[1], 10);
                let minDay = Number.parseInt(minDateGreg.split('-')[2], 10);
                if (minDay == 30 && minMonth == 12) {
                    this.years = this.years.filter(function (yr, idx) {
                        return yr > minYear;
                    });
                }
                else {
                    this.years = this.years.filter(function (yr, idx) {
                        return yr >= minYear;
                    });
                }
            }
        }

        generateMonths() {
            this.months = [];
            const { isGregorianInternal, hijriMonths, gregorianMonths } = this;
            const { maxDateInternal, minDateInternal, selectedYear } = this;
            const [maxYear, maxMonth] = maxDateInternal.split('-').map(Number);

            for (let i = 1; i <= 12; i++) {
                const name = isGregorianInternal ? gregorianMonths[i - 1] : hijriMonths[i - 1];
                const value = i;
                this.months.push({ name, value });
            }

            if (maxDateInternal) {
                if (selectedYear === maxYear) {
                    this.months = this.months.filter(m => m.value <= maxMonth);
                }
            }

            if (minDateInternal) {
                const minDateGreg = isGregorianInternal
                    ? momenthijri(this.minDateInternal.trim(), 'iYYYY-iMM-iDD').format('YYYY-MM-DD')
                    : this.minDateInternal;
                const [minYear, minMonth, minDay] = minDateGreg.split('-').map(Number);

                if (!isGregorianInternal) {
                    if (minDay === 30 && selectedYear === minYear) {
                        this.months = this.months.filter(m => m.value > minMonth);
                    } else if (minDay < 30 && selectedYear === minYear) {
                        this.months = this.months.filter(m => m.value >= minMonth);
                    }
                } else { //تاريخ ميلادي

                    const isMinDayLessThan30 = minDay < 30 && minDay !== 28;
                    const isMinMonthInArray = [4, 6, 8, 10, 12].includes(minMonth);
                    const isMinMonthInArray2 = [1, 3, 5, 7, 9, 11].includes(minMonth);
                    const isFebruary28 = minDay === 28 && minMonth === 2;

                    if (isMinDayLessThan30 && selectedYear === minYear) {
                        this.months = this.months.filter(m => m.value >= minMonth);

                    } else if (isMinMonthInArray && selectedYear === minYear) {
                        this.months = this.months.filter(m => m.value > minMonth);

                    } else if (isMinMonthInArray2 && selectedYear === minYear) {
                        this.months = this.months.filter(m => m.value > minMonth);

                    } else if (isFebruary28 && selectedYear === minYear) {
                        this.months = this.months.filter(m => m.value > minMonth);
                    }
                }
            }
        }

        getDays(month: number, year: number) {
            this.days = [];
            let daysCount = 0;

            if (this.isGregorianInternal) {
                daysCount = moment(year + '-' + month, 'yyyy-MM').daysInMonth();
            } else {
                daysCount = 30;
            }
            while (daysCount >= 1) {
                this.days.push(daysCount);
                daysCount--;
            }

            if (this.maxDateInternal != '') {
                let maxDay = Number.parseInt(this.maxDateInternal.split('-')[2], 10);
                let maxYear = Number.parseInt(this.maxDateInternal.split('-')[0], 10);
                let maxMonth = Number.parseInt(this.maxDateInternal.split('-')[1], 10);
                if (this.selectedYear == maxYear && month == maxMonth) {
                    this.days = this.days.filter(function (d, idx) {
                        return d <= maxDay;
                    });
                }
            }

            if (!this.isGregorianInternal && this.minDateInternal != '') {//hijri
                let minYear = Number.parseInt(this.minDateInternal.split('-')[0], 10);
                let minMonth = Number.parseInt(this.minDateInternal.split('-')[1], 10);
                let minDay = Number.parseInt(this.minDateInternal.split('-')[2], 10);
                if (month === minMonth && year === minYear) {
                    this.days = this.days.filter(function (d, idx) {
                        return d > minDay;
                    });
                }
            }
            else if (this.isGregorianInternal && this.minDateInternal != '') {
                var minDateGreg = momenthijri(this.minDateInternal.trim(), 'iYYYY-iMM-iDD').format('YYYY-MM-DD');
                let minYear = Number.parseInt(minDateGreg.split('-')[0], 10);
                let minMonth = Number.parseInt(minDateGreg.split('-')[1], 10);
                let minDay = Number.parseInt(minDateGreg.split('-')[2], 10);
                if (month === minMonth && year === minYear) {
                    this.days = this.days.filter(function (d, idx) {
                        return d > minDay;
                    });
                }
            }
        }

        calendarTypeChange() {
            this.clear()
            if (this.isGregorianInternal) {
                this.currentDate = moment().format('YYYY-MM-DD');
            } else {
                this.currentDate = momenthijri().format('iYYYY-iMM-iDD');
            }

            if (this.maxDate.trim().toLowerCase() != '') {
                if (this.maxDate.toLowerCase() == 'today') {
                    this.maxDateInternal = this.isGregorianInternal ?
                        moment().format('YYYY-MM-DD') : momenthijri().format('iYYYY-iMM-iDD');
                }
                else {
                    this.maxDateInternal = this.isGregorianInternal ?
                        moment(this.maxDate.trim(), 'yyyy-MM-dd').format('YYYY-MM-DD') : moment(this.maxDate.trim(), 'yyyy-MM-dd').format('iYYYY-iMM-iDD');
                }
            }

            this.generateYears();
            this.generateMonths();
            this.getDays(Number.parseInt(this.currentDate.split('-')[1], 10)
                , Number.parseInt(this.currentDate.split('-')[0], 10));
            this.fillDates();
        }

        fillDates() {
            if (this.selectedYear && this.selectedMonth && this.selectedDay) {
                let selectedDate = this.selectedYear + '-' + this.selectedMonth.value + '-' + this.selectedDay;
                if (this.isGregorianInternal) {
                    let selectedGregDate = momenthijri(selectedDate, 'iYYYY-iMM-iDD').format('YYYY-MM-DD');
                    this.selectedYear = Number.parseInt(selectedGregDate.split('-')[0]);
                    this.selectedMonth = this.months.find((x) =>
                        x.value === Number.parseInt(selectedGregDate.split('-')[1], 10)) as any;
                    this.selectedDay = Number.parseInt(selectedGregDate.split('-')[2]);
                }
                else {
                    let selectedHijDate = momenthijri(selectedDate, 'YYYY-MM-DD').format('iYYYY-iMM-iDD');
                    if (selectedHijDate == "1355-12-NaN") {
                        this.selectedYear = 0;
                        this.selectedMonth = null;
                        this.selectedDay = 0;
                    }
                    else {
                        this.selectedYear = Number.parseInt(selectedHijDate.split('-')[0]);
                        this.selectedMonth = this.months.find((x) =>
                            x.value === Number.parseInt(selectedHijDate.split('-')[1], 10)) as any;
                        this.selectedDay = Number.parseInt(selectedHijDate.split('-')[2]);
                    }
                }
            }
            else {
                this.selectedYear = 0;
                this.selectedMonth = null;
                this.selectedDay = 0;
            }

            let changedDate: DDCalendarDate = {
                isGregorian: this.isGregorianInternal,
                gregDate: '',
                hijriDate: '',
                date: new Date(Date.now())
            };

            if (this.selectedYear && this.selectedMonth && this.selectedMonth.value !== 0 && this.selectedDay) {
                let selectedDate = this.selectedYear + '-' + this.selectedMonth.value.toString().padStart(2, '0') + '-' + this.selectedDay.toString().padStart(2, '0');
                if (!this.isGregorianInternal) {
                    let selectedGregDate = momenthijri(selectedDate, 'iYYYY-iMM-iDD').format('YYYY-MM-DD');
                    if (selectedGregDate != "1001-03-01")
                        changedDate.gregDate = selectedGregDate;
                    changedDate.hijriDate = selectedDate;
                }
                else {
                    let selectedHijDate = momenthijri(selectedDate, 'YYYY-MM-DD').format('iYYYY-iMM-iDD');
                    if (selectedHijDate != "1355-12-NaN")
                        changedDate.hijriDate = selectedHijDate;
                    changedDate.gregDate = selectedDate;
                }
            }
            if (!this.isConditionControl) {
                this.$emit('dateChanged', changedDate);
            }
            else {
                if (changedDate.hijriDate == '' || changedDate.gregDate == '') {
                    this.isValid = false;
                }
                else {
                    this.isValid = true;
                }
                this.$emit('controlDataChanged', { value: changedDate, index: this.index, isValid: this.isValid });
            }



        }
        onSelectedYearChange(Year: number) {
            this.selectedMonth = null;
            this.selectedDay = 0;
            this.generateMonths();
            this.updateChangedDate();
        }
        onSelectedMonthChange(selectedMonth: any) {
            this.selectedDay = 0;
            this.getDays(selectedMonth.value, this.selectedYear);//Number.parseInt(this.selectedYear, 10));
            this.updateChangedDate();
        }
        onSelectedDayChange(day: string) {
            this.updateChangedDate();
        }
        updateChangedDate() {
            let changedDate: DDCalendarDate = {
                isGregorian: this.isGregorianInternal,
                gregDate: '',
                hijriDate: '',
                date: new Date(Date.now())
            };

            if (this.selectedYear && this.selectedMonth && this.selectedMonth.value !== 0 && this.selectedDay) {
                let selectedDate = this.selectedYear + '-' + this.selectedMonth.value.toString().padStart(2, '0') + '-' + this.selectedDay.toString().padStart(2, '0');
                if (!this.isGregorianInternal) {
                    let selectedGregDate = momenthijri(selectedDate, 'iYYYY-iMM-iDD').format('YYYY-MM-DD');
                    if (selectedGregDate != "1001-03-01")
                        changedDate.gregDate = selectedGregDate;
                    changedDate.hijriDate = selectedDate;
                }
                else {
                    let selectedHijDate = momenthijri(selectedDate, 'YYYY-MM-DD').format('iYYYY-iMM-iDD');
                    if (selectedHijDate != "1355-12-NaN")
                        changedDate.hijriDate = selectedHijDate;
                    changedDate.gregDate = selectedDate;
                }
            }
            //this.$emit('dateChanged', changedDate);
            if (!this.isConditionControl) {
                this.$emit('dateChanged', changedDate);
            }
            else {
                if (changedDate.hijriDate == '' || changedDate.gregDate == '') {
                    this.isValid = false;
                }
                else {
                    this.isValid = true;
                }
                this.$emit('controlDataChanged', { value: changedDate, index: this.index, isValid: this.isValid });
            }


        }
        isNumber(evt: any) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            }
        }
        clear() {
            this.selectedYear = 0;
            this.selectedMonth = null;
            this.selectedDay = 0;
        }


    }
</script>

<style lang="scss">
.dd-calendar .v-input__control .v-input__icon--append i.mdi {
  color: var(--v-primary-base);
}

.wide-input div[role='combobox'] {
  padding: 0 8px !important;
}

.dd-calendar .dd-switch-aligned {
  margin-top: 5px;
}

.dd-calendar .rounded-0 .v-input__control .v-input__slot>fieldset {
  border-color: #e4e5e6;
}

.dd-calendar .v-input__append-inner {
  margin-top: 14px !important;
  cursor: pointer;
}

.dd-calendar .v-select__slot .v-label {
  margin-top: 5px !important;
}
</style>
